const CONFIG = {
    baseUrl : 'https://api.babyier.rocks:8081/canela' //'https://myp-trainer.herokuapp.com'//
    ,
    urlVFace : "https://api.vface.com.br:8082/vfaceweb"
}
export default CONFIG;